/**
 * Compact segmented locale toggle (EN | PT). Used in the app shell's nav meta
 * and on the login card — the two places a user picks a language. Buttons over
 * a <select>: two options, one tap, visible current state.
 */

import { useI18n } from './I18nProvider'
import { LOCALES, type Locale } from './locale'

const SHORT_LABEL: Record<Locale, string> = { en: 'EN', 'pt-BR': 'PT' }

export function LanguageSwitcher() {
  const { locale, setLocale, t } = useI18n()
  const nameOf = (l: Locale) => (l === 'en' ? t.common.languageNameEn : t.common.languageNamePt)

  return (
    <fieldset className="lang-switch" aria-label={t.common.language}>
      {LOCALES.map((l) => (
        <button
          key={l}
          type="button"
          className={`lang-switch-btn${l === locale ? ' on' : ''}`}
          aria-pressed={l === locale}
          title={nameOf(l)}
          lang={l}
          onClick={() => setLocale(l)}
        >
          {SHORT_LABEL[l]}
        </button>
      ))}
    </fieldset>
  )
}
